import { jsx as _jsx } from "react/jsx-runtime";
import { HStack } from "@chakra-ui/react";
import { AnchorLink } from "@/components/LinkComponents/AnchorLink";
export var FooterLinks = function () {
    var anchors = ["Privacy", "Cookie", "Use", "Terms"];
    var linksComponents = anchors.map(function (anchor, id) {
        return _jsx(AnchorLink, { anchor: anchor, variant: "footer" }, id);
    });
    return _jsx(HStack, { children: linksComponents });
};
